"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_143)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_143`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.0210571V24H30V0.0210571H-6Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.2491 10.4492H14.1053L12.5123 5.55792L10.9193 10.4492H5.77545L9.93686 13.4737L8.34387 18.3649L12.5053 15.3404L16.6667 18.3649L15.0877 13.4737L19.2491 10.4492ZM11.1018 13.0948L11.6421 11.4386H13.3825L13.9228 13.0948L12.5123 14.1193L11.1018 13.0948ZM13.0597 10.4492H11.9649L12.5123 8.76494L13.0597 10.4492ZM14.7649 12.4842L14.4281 11.4386H16.2035L14.7649 12.4842ZM10.6035 11.4386L10.2667 12.4842L8.82808 11.4386H10.6035ZM10.2316 15.7755L10.779 14.0913L11.6632 14.7369L10.2316 15.7755ZM13.3544 14.7299L14.2386 14.0842L14.786 15.7684L13.3544 14.7299Z",
					fill: "#20661B"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_143`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MAFlag };
